import React from "react"
import { StyleSheet, Text, TouchableOpacity, View } from "react-native"
import * as Animatable from "react-native-animatable"
import Icon from "react-native-vector-icons/Ionicons"
import { useMediaQuery } from "react-responsive"

import Base from "../../../../base"
import { CustomSwitch } from "../../../common"
import Gap from "../../../common/Gap"

export default function OptionRow(props) {
  const isMobile = useMediaQuery(Base.constants.mobile)
  const rotate = !props.isOpen ? "0deg" : "180deg"

  function statusChange(value) {
    props.onStatusChange(props.item, !!value)
  }

  return (
    <TouchableOpacity
      style={[styles.main, props.style]}
      onPress={() => props.onPress(props.item)}
      activeOpacity={0.7}
    >
      <Text style={styles.title}>{props.item?.name}</Text>
      {!props.isFlooid && (
        <View style={styles.switches}>
          <CustomSwitch
            value={props.item.enabled}
            small={true}
            onValueChange={statusChange}
          />
          <Gap size={isMobile ? 90 : 130} horizontal />
        </View>
      )}
      <View style={[styles.arrowWrap, isMobile && styles.arrowWrap_sm]}>
        <Animatable.View transition="rotate" style={{ rotate }}>
          <Icon name="ios-arrow-down" size={20} color={Base.colours.appRed} />
        </Animatable.View>
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  main: {
    flexDirection: "row",
    height: 48,
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomColor: Base.colours.appSemiLightGrey,
    borderBottomWidth: 1,
  },

  title: {
    flex: 1,
    marginEnd: 10,
    fontSize: 16,
    color: Base.colours.appGreen,
    fontFamily: Base.fonts.appExtraBold,
  },

  switches: {
    flexDirection: "row",
  },

  arrowWrap: {
    width: 80,
    alignItems: "flex-end",
  },
  arrowWrap_sm: {
    width: 20,
  },
})
